// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2mcuG","wrapper_gray":"wrapper_gray-27GLV"};